import { render, staticRenderFns } from "./darah_keluar.vue?vue&type=template&id=e21792ac&scoped=true"
import script from "./darah_keluar.vue?vue&type=script&lang=js"
export * from "./darah_keluar.vue?vue&type=script&lang=js"
import style0 from "./darah_keluar.vue?vue&type=style&index=0&id=e21792ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21792ac",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QSelect,QIcon,QBadge,QPagination} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QSelect,QIcon,QBadge,QPagination})
